import { SearchConditionsParams, useSearchCondition } from '@/component/FilterCommon/hooks/useSearchCondition';
import { isErrorMobile,isErrorMobile100} from '@/component/PageComponentMobile/error';
import React from 'react';
import { serviceSearchConditions, } from '../services/searchCondition';



export const useSearchConditionMobile = <T extends SearchConditionsParams>(conditionParams: T,options?:{
  manual?: boolean,
  visible?:boolean,
},) => {
  const { manual } = options || {}
  const [visible, setVisible] = React.useState<boolean>(false);
  let baseUseCondition =  useSearchCondition<T>(conditionParams,{serviceSearchConditions:serviceSearchConditions,manual:manual,isError:isErrorMobile100})
  React.useEffect(()=>{
    if(visible){
      baseUseCondition.getInitData()
    }
  },[visible])
  return {
    ...baseUseCondition,
    visible,
    toggle:()=>{
      setVisible(v =>!v)
    }
  }
}
